import merge from "deepmerge";
import { defaultTheme } from "scmp-sdk/components/newsletter/newsletter-widget/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

export const mergeTheme = (theme: ThemeType) => merge(defaultTheme, theme);
